import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      /* --- BENDRI --- */
      back: "Back", close: "Close", save: "Save", cancel: "Cancel", delete: "Delete", edit: "Edit", info: "Info", actions: "Actions",
      search: "Search", uploadFile: "Upload file", loading: "Loading...", login: "Login", logout: "Logout",
      
      /* --- DARBUOTOJAI IR DARBAS --- */
      workHours: "Work Hours", worker: "Worker", workers: "Workers", no_workers: "No workers found.", open: "Open", day: "Day",
      workStart: "Start", workEnd: "End", breakTime: "Break", project: "Project", projects: "Projects", other: "Other",
      add_column: "Add Column", total_netto: "Total Netto", email_open: "Email app opened.", saved: "Saved!", error: "Error.",
      weekly_plan: "Weekly Plan", start_work: "Start Work", no_work_this_week: "No work this week",
      
      /* --- SAVAITĖS DIENOS --- */
      monday: "Monday", tuesday: "Tuesday", wednesday: "Wednesday", thursday: "Thursday", friday: "Friday", saturday: "Saturday", sunday: "Sunday",
      days: { Mo: "Mo", Di: "Tu", Mi: "We", Do: "Th", Fr: "Fr", Sa: "Sa", So: "Su" },

      /* --- KONTAKTAI IR INFO --- */
      client: "Client", address: "Address", contact_person: "Contact Person", contact: "Contact", accommodation: "Accommodation", phone: "Phone",
      transport: "Transport", comment: "Comment", employees: "Employees",
      
      /* --- DOKUMENTAI --- */
      documents: "Documents", photos: "Photos", chat: "Chat", library: "Library", warehouse: "Warehouse",
      company_documents: "Company Documents", company_docs_desc: "Internal rules, contracts.", new_document: "New Document",
      documentName: "Document Name", description: "Description", send_to_all: "Send to ALL", require_signature: "Require Signature",
      send: "Send", all_workers: "All Workers", assigned_to: "Assigned to", signed_count: "Signed", doc_count: "docs",
      addDocument: "Add Document", signatures: "Signatures", no_signatures: "No signatures yet.", no_file_preview: "No preview available.",
      
      /* --- ADMIN PANELĖ --- */
      admin_dashboard: "Admin Dashboard", acts: "Acts", maps: "Live Map", fahrtenbuch: "Trip Log", settings: "Settings",
      live_location: "LIVE LOCATION", history: "History", map_streets: "Streets", map_satellite: "Satellite", waiting: "Waiting",
      workerInfo: "Worker Information", name: "Name", email: "Email", loginCode: "Login Code", codeUsed: "Used", codeActive: "Active",
      noDocuments: "No documents.", uploadDocument: "Upload Document", regenerate: "Regenerate", copy: "Copy",
      
      /* --- BIOMETRIJA (NAUJA) --- */
      face_id: "Face ID", fingerprint: "Fingerprint", language: "Language", failed_faceid: "Face ID failed",
      failed_fingerprint: "Fingerprint failed", too_many_attempts: "Too many attempts.",
      biometric_title: "Biometric Login",
      biometric_subtitle: "Scan Face or Fingerprint",
      biometric_description: "Confirm your identity",
      biometrics_not_supported: "Biometrics not supported on this device.",

      kw: "CW", no_projects: "No projects found.", select_project_error: "Please select a project!",
      
      /* --- STATUSAI --- */
      confirm_end_work: "Finish work?", work: "Work", off: "Off", sick: "Sick", vacation: "Vacation", holiday: "Holiday",
      select_status: "Select Status", create_and_send: "Create & Send", sending: "Sending...", sent: "Sent",
      sent_projects: "Sent Projects", sureDelete: "Delete this?", error_no_workers: "No workers with 'Work' status found!",
      conflict_warning: "{{name}} is already assigned to '{{project}}' on {{day}}. Assign here too?",
      addWorker: "Add Worker", code_copied: "Code copied!", confirm_regenerate_code: "Generate new code?",
      v11_feature_alert: "Available in v1.1", live_gps: "Live GPS", no_gps: "No GPS",
      
      /* --- TAISYKLĖS --- */
      rules_work_hours: "Work Hours Rules", rule_actual_time: "Actual time recorded", rule_no_overtime: "No overtime calc",
      rule_manual_adj: "Manual adjustments", rule_exported_data: "Final admin values", rules_break_auto: "Break Rules",
      rule_break_up_to_6h: "6h -> 30min", rule_break_more_6h: "6h+ -> 60min", rule_break_auto_applied: "Auto break applied",
      important_notice: "Important", legal_disclaimer: "Admin responsibility.",
      
      /* --- ATASKAITOS --- */
      total: "TOTAL", month: "Month", netto: "Netto", email_subject: "Work hours", email_greeting: "Hello", email_body_text: "Report for",
      error_title_required: "Title required!", error_select_worker: "Select worker!", sending_success: "Sent!",
      protocol_title: "SIGNATURE PROTOCOL", document_label: "Document", created_at: "Created", original_file: "File",
      file_link: "Link", click_to_open: "Click to open", signatures_section: "SIGNATURES", signed_name: "Name", signed_date: "Date",
      timesheet_title: "Arbeitszeitnachweis / Time Sheet", company: "Company",
      error_missing_project_info: "Please enter project details and assign workers first!",
      weekly_plan_pdf: "Weekly Plan PDF", search_and_filter: "Search / Filter...", search_tooltip_hint: "Filter projects", print_pdf: "PDF / PRINT",
      project_info: "Project Info", no_projects_found: "No projects found.", copy_to_another_kw: "Copy to CW", select_kw: "SELECT WEEK",
      with_workers: "With workers", copy_to_kw: "MOVE TO WEEK", cancel_edit: "CANCEL EDITING", no_changes: "No changes.",
      data_saved: "Data saved!", custom_status_warning: "Custom status warning", new_status_placeholder: "New status name...",
      duplicate_worker_error: "Worker already exists!", add_custom_field: "Add Field", field_name: "Field Name",
      field_value: "Value", upload_docs_label: "Documents", upload_btn: "Upload", selected_files: "Selected files:",
      error_saving: "Error saving: ", editing: "Editing", update: "Update",
      project_budget: "Project Budget", sum: "Sum", add_line: "Add line", example_desc: "e.g. Concrete...",
      project_value: "Project Value", plan_budget: "Plan Budget", new_project: "New Project", quantity: "Qty", unit: "Unit", price: "Price",

      /* --- PAPILDOMI --- */
      attention: "Attention", no_new_changes: "No new changes found.",
      export_mode: "EXPORT MODE", export: "EXPORT", category: "Category", additional_info: "Additional Info", add_field: "Add Field",
      view: "View", remove_from_project: "Remove from project", car: "Car", hotel: "Hotel", admin: "Admin", pdf_print: "PDF / Print",
      date: "Date", company_profile: "Company Profile", edit_profile: "Edit Profile", company_name: "Company Name",
      vat_id: "VAT ID", phone_number: "Phone", street_and_number: "Street", postal_code: "Zip Code", city: "City",
      work_email: "Work Email", cancel_changes: "Cancel changes", team_management: "Team", locked: "Locked", password: "Password",
      add_sub_admin: "Add Sub-Admin", generate_access: "Generate Access", plan_and_limits: "Plan & Limits", upgrade: "Upgrade",
      worker_limit: "Worker limit", admin_limit: "Admin limit", read_only: "Read-Only", limit_reached: "Limit reached!",
      error_name_required: "Name required!",

      /* --- PARAŠO FUNKCIJOS --- */
      draw_signature: "Please sign here:",
      clear: "Clear",
      confirm_signature: "Confirm Signature",
      please_sign: "Please sign first (empty).",
      confirm_sign_doc: "Do you really want to sign and send this?",
      signed_successfully: "Signed successfully!",
      sign_document: "Sign Document",
      open_file: "Open File",
      signed: "Signed",
      your_signature: "Your Signature",
      signature: "Signature",
      tap_to_sign: "Tap to sign",

      /* --- ARCHIVE --- */
      archive: "Archive",
      archive_description: "Workers here do not occupy plan spots.",
      back_to_list: "Back to list",
      restore: "Restore",
      delete_permanently: "Delete permanently",
      restore_confirm: "Are you sure you want to restore:",
      delete_permanent_confirm: "WARNING! This will delete the worker and history permanently. Continue?",
      restore_limit_error: "Cannot restore! Plan limit reached.",
      archive_empty: "Archive is empty",
      archive_worker_confirm: "Archive worker?",
      archive_worker_desc: "Worker will be moved to archive. History is kept, plan spot is freed.",

      /* --- REPORTS --- */
      photo_report_title: "PHOTO REPORT",
      photo_num: "Photo",
      no_photos_yet: "No photos yet",
      add_photo: "Add Photo",
      general_comment_uppercase: "GENERAL COMMENTS",
      general_comment: "General Comment",
      worker_signature: "Worker Signature",
      client_signature: "Signature (Client / Other)",
      verified_by: "Verified by / Signature",
      save_offline_btn: "Save (Offline)",
      send_btn: "Send",
      sent_success: "Sent!",
      share: "Share",
      empty_history: "Empty",
      photo_comment_placeholder: "Comment...",
      reports_title: "Reports",
      no_photos_in_record: "No photos in this record.",
      generated_by_system: "Generated by BuildForce AL",
      no_comment: "No comment",
      
      /* --- DASHBOARD --- */
      status_viewed: "Viewed",
      status_new: "New",
      status_completed: "Completed",
      view_all: "View all",
      no_date: "No date",
      generating: "Generating...",
      download_pdf: "Download PDF",
      no_reports: "No reports found.",
      unknown_worker: "Unknown",
      unknown_project: "Unknown",
      confirm_delete: "Are you sure you want to delete?",
      no_info: "No info",

      /* --- NAUJI (PROFILE & SHARE) --- */
      profile: "Profile",
      personal_data: "Personal Data",
      data_managed_by_admin: "Data is managed by the administrator.",
      shared_success: "Shared",
      error_sending_failed: "Sending failed",
      share_error: "Share failed"
    }
  },

  de: {
    translation: {
      back: "Zurück", close: "Schließen", save: "Speichern", cancel: "Abbrechen", delete: "Löschen", edit: "Bearbeiten", info: "Info", actions: "Aktionen",
      search: "Suche", uploadFile: "Datei hochladen", loading: "Laden...", login: "Anmelden", logout: "Abmelden",
      workHours: "Arbeitsstunden", worker: "Mitarbeiter", workers: "Mitarbeiter", no_workers: "Keine Mitarbeiter.", open: "Öffnen", day: "Tag",
      workStart: "Beginn", workEnd: "Ende", breakTime: "Pause", project: "Projekt", projects: "Projekte", other: "Sonstiges",
      add_column: "Spalte hinzufügen", total_netto: "Gesamt Netto", email_open: "E-Mail geöffnet.", saved: "Gespeichert!", error: "Fehler.",
      weekly_plan: "Wochenplan", start_work: "Arbeit starten", no_work_this_week: "Keine Arbeit diese Woche",
      monday: "Montag", tuesday: "Dienstag", wednesday: "Mittwoch", thursday: "Donnerstag", friday: "Freitag", saturday: "Samstag", sunday: "Sonntag",
      days: { Mo: "Mo", Di: "Di", Mi: "Mi", Do: "Do", Fr: "Fr", Sa: "Sa", So: "So" },
      client: "Auftraggeber", address: "Adresse", contact_person: "Ansprechpartner", contact: "Kontakt", accommodation: "Unterkunft", phone: "Telefon",
      transport: "Transport", comment: "Kommentar", employees: "Mitarbeiter",
      documents: "Dokumente", photos: "Fotos", chat: "Chat", library: "Bibliothek", warehouse: "Lager",
      company_documents: "Firmendokumente", company_docs_desc: "Regeln, Verträge.", new_document: "Neues Dokument",
      documentName: "Dokumentname", description: "Beschreibung", send_to_all: "An ALLE senden", require_signature: "Unterschrift erforderlich",
      send: "Senden", all_workers: "Alle Mitarbeiter", assigned_to: "Zugewiesen an", signed_count: "Unterschrieben", doc_count: "dok.",
      addDocument: "Dokument hinzufügen", signatures: "Unterschriften", no_signatures: "Noch keine Unterschriften.", no_file_preview: "Keine Vorschau verfügbar.",
      admin_dashboard: "Dashboard", acts: "Akten", maps: "Karte", fahrtenbuch: "Fahrtenbuch", settings: "Einstellungen",
      live_location: "LIVE STANDORT", history: "Verlauf", map_streets: "Straßen", map_satellite: "Satellit", waiting: "Warten",
      workerInfo: "Mitarbeiterinfo", name: "Name", email: "E-Mail", loginCode: "Zugangscode", codeUsed: "Benutzt", codeActive: "Aktiv",
      noDocuments: "Keine Dokumente.", uploadDocument: "Dokument hochladen", regenerate: "Neu generieren", copy: "Kopieren",
      
      /* --- BIOMETRIJA (NAUJA) --- */
      face_id: "Face ID", fingerprint: "Fingerabdruck", language: "Sprache", failed_faceid: "Face ID fehlgeschlagen",
      failed_fingerprint: "Fingerabdruck fehlgeschlagen", too_many_attempts: "Zu viele Versuche.",
      biometric_title: "Biometrische Anmeldung",
      biometric_subtitle: "Gesicht oder Fingerabdruck scannen",
      biometric_description: "Bitte bestätigen Sie Ihre Identität",
      biometrics_not_supported: "Biometrie wird nicht unterstützt.",

      kw: "KW", no_projects: "Keine Projekte gefunden.", select_project_error: "Projekt wählen!",
      confirm_end_work: "Arbeit beenden?", work: "Arbeit", off: "Frei", sick: "Krank", vacation: "Urlaub", holiday: "Feiertag",
      select_status: "Status", create_and_send: "Erstellen & Senden", sending: "Wird gesendet...", sent: "Gesendet",
      sent_projects: "Projekte", sureDelete: "Löschen?", error_no_workers: "Keine Mitarbeiter an der Arbeit!",
      conflict_warning: "{{name}} ist bereits '{{project}}' am {{day}} zugewiesen. Auch hier zuweisen?",
      addWorker: "Mitarbeiter hinzufügen", code_copied: "Code kopiert!", confirm_regenerate_code: "Neuen Code generieren?",
      v11_feature_alert: "Verfügbar in v1.1", live_gps: "Live GPS", no_gps: "Kein GPS",
      rules_work_hours: "Arbeitsstunden Regeln", rule_actual_time: "Tatsächliche Zeit", rule_no_overtime: "Keine Überstunden",
      rule_manual_adj: "Manuelle Korrektur", rule_exported_data: "Admin-Werte", rules_break_auto: "Pause",
      rule_break_up_to_6h: "6h -> 30min", rule_break_more_6h: "6h+ -> 60min", rule_break_auto_applied: "Auto-Pause",
      important_notice: "Wichtig", legal_disclaimer: "Admin Verantwortung.",
      total: "GESAMT", month: "Monat", netto: "Netto", email_subject: "Bericht", email_greeting: "Hallo", email_body_text: "Anbei der Bericht für",
      error_title_required: "Titel erforderlich!", error_select_worker: "Wählen Sie Mitarbeiter!", sending_success: "Gesendet!",
      protocol_title: "UNTERSCHRIFTENPROTOKOLL", document_label: "Dokument", created_at: "Erstellt am", original_file: "Originaldatei",
      file_link: "Link", click_to_open: "Klicken zum Öffnen", signatures_section: "UNTERSCHRIFTEN", signed_name: "Name", signed_date: "Datum",
      timesheet_title: "Arbeitszeitnachweis / Time Sheet", company: "Firma",
      error_missing_project_info: "Bitte Objekt eingeben!",
      weekly_plan_pdf: "Wochenplan PDF", search_and_filter: "Suchen / Filtern...", search_tooltip_hint: "Druckfilter", print_pdf: "PDF / DRUCKEN",
      project_info: "Projekt Info", no_projects_found: "Keine Projekte gefunden.", copy_to_another_kw: "In andere Woche kopieren",
      select_kw: "KW AUSWÄHLEN", with_workers: "Mit Mitarbeitern", copy_to_kw: "IN ANDERE KW VERSCHIEBEN",
      cancel_edit: "BEARBEITUNG ABBRECHEN", no_changes: "Keine Änderungen.", data_saved: "Daten gespeichert!",
      custom_status_warning: "Benutzerdefinierter Status", new_status_placeholder: "Neuer Statusname...",
      duplicate_worker_error: "Mitarbeiter existiert bereits!", add_custom_field: "Zusatzfeld hinzufügen",
      field_name: "Feldname", field_value: "Wert", upload_docs_label: "Dokumente", upload_btn: "Hochladen",
      selected_files: "Ausgewählte Dateien:", error_saving: "Fehler: ", editing: "Bearbeiten", update: "Aktualisieren",
      project_budget: "Projektbudget", sum: "Summe", add_line: "Zeile hinzufügen", example_desc: "z.B. Beton...",
      project_value: "Projektwert", plan_budget: "Budget planen", new_project: "Neues Projekt", quantity: "Menge", unit: "Einh.", price: "Preis",
      attention: "Achtung", no_new_changes: "Keine neuen Änderungen gefunden.",
      export_mode: "EXPORTMODUS", export: "EXPORT", category: "Kategorie", additional_info: "Zusatzinfo", add_field: "Feld hinzufügen",
      view: "Ansehen", remove_from_project: "Vom Projekt entfernen", car: "Auto", hotel: "Unterkunft", admin: "Admin",
      pdf_print: "PDF / Drucken", date: "Datum", company_profile: "Unternehmensprofil", edit_profile: "Profil bearbeiten",
      company_name: "Firmenname", vat_id: "USt-IdNr.", phone_number: "Telefon", street_and_number: "Straße", postal_code: "PLZ",
      city: "Stadt", work_email: "Arbeits-E-Mail", cancel_changes: "Abbrechen", team_management: "Team", locked: "Gesperrt",
      password: "Passwort", add_sub_admin: "Sub-Admin hinzufügen", generate_access: "Zugang generieren",
      plan_and_limits: "Plan & Limits", upgrade: "Upgrade", worker_limit: "Mitarbeiterlimit", admin_limit: "Adminlimit",
      read_only: "Nur Lesezugriff", limit_reached: "Limit erreicht!", error_name_required: "Name erforderlich!",
      draw_signature: "Bitte hier unterschreiben:",
      clear: "Löschen",
      confirm_signature: "Unterschrift bestätigen",
      please_sign: "Bitte zuerst unterschreiben.",
      confirm_sign_doc: "Möchten Sie dieses Dokument wirklich unterschreiben und senden?",
      signed_successfully: "Erfolgreich unterschrieben!",
      sign_document: "Dokument unterschreiben",
      open_file: "Datei öffnen",
      signed: "Unterschrieben",
      your_signature: "Ihre Unterschrift",
      signature: "Unterschrift",
      tap_to_sign: "Tippen zum Unterschreiben",
      archive: "Archiv",
      archive_description: "Diese Mitarbeiter belegen keine Planplätze.",
      back_to_list: "Zurück zur Liste",
      restore: "Wiederherstellen",
      delete_permanently: "Endgültig löschen",
      restore_confirm: "Möchten Sie diesen Mitarbeiter wirklich wiederherstellen:",
      delete_permanent_confirm: "ACHTUNG! Dies löscht den Mitarbeiter und seine gesamte Historie unwiderruflich. Fortfahren?",
      restore_limit_error: "Wiederherstellung nicht möglich! Planlimit erreicht.",
      archive_empty: "Das Archiv ist leer",
      archive_worker_confirm: "Mitarbeiter archivieren?",
      archive_worker_desc: "Der Mitarbeiter wird ins Archiv verschoben. Die Historie bleibt erhalten, der Platz im Plan wird frei.",
      photo_report_title: "FOTOBERICHT",
      photo_num: "Foto",
      no_photos_yet: "Noch keine Fotos",
      add_photo: "Foto hinzufügen",
      general_comment_uppercase: "ALLGEMEINE KOMMENTARE",
      general_comment: "Allgemeiner Kommentar",
      worker_signature: "Mitarbeiterunterschrift",
      client_signature: "Unterschrift (Kunde / Sonstiges)",
      verified_by: "Bestätigt von / Unterschrift",
      save_offline_btn: "Speichern (Offline)",
      send_btn: "Senden",
      sent_success: "Gesendet!",
      share: "Teilen",
      empty_history: "Leer",
      photo_comment_placeholder: "Kommentar...",
      reports_title: "Berichte",
      no_photos_in_record: "Keine Fotos in diesem Datensatz.",
      generated_by_system: "Erstellt von BuildForce AL",
      no_comment: "Kein Kommentar",
      status_viewed: "Gesehen",
      status_new: "Neu",
      status_completed: "Erledigt",
      view_all: "Alle ansehen",
      no_date: "Kein Datum",
      generating: "Generiere...",
      download_pdf: "PDF herunterladen",
      no_reports: "Keine Berichte gefunden.",
      unknown_worker: "Unbekannt",
      unknown_project: "Unbekannt",
      confirm_delete: "Möchten Sie wirklich löschen?",
      no_info: "Keine Info",

      /* --- NAUJI (PROFILE & SHARE) --- */
      profile: "Profil",
      personal_data: "Persönliche Daten",
      data_managed_by_admin: "Daten werden vom Administrator verwaltet.",
      shared_success: "Geteilt",
      error_sending_failed: "Senden fehlgeschlagen",
      share_error: "Teilen fehlgeschlagen"
    }
  },

  lt: {
    translation: {
      back: "Atgal", close: "Uždaryti", save: "Išsaugoti", cancel: "Atšaukti", delete: "Ištrinti", edit: "Redaguoti", info: "Info", actions: "Veiksmai",
      search: "Paieška", uploadFile: "Įkelti failą", loading: "Kraunama...", login: "Prisijungti", logout: "Atsijungti",
      workHours: "Darbo valandos", worker: "Darbuotojas", workers: "Darbuotojai", no_workers: "Darbuotojų nerasta.", open: "Atidaryti", day: "Diena",
      workStart: "Pradžia", workEnd: "Pabaiga", breakTime: "Pertrauka", project: "Projektas", projects: "Projektai", other: "Kita",
      add_column: "Pridėti stulpelį", total_netto: "VISO Netto", email_open: "El. paštas atidarytas.", saved: "Išsaugota!", error: "Klaida.",
      weekly_plan: "Savaitės planas", start_work: "Pradėti darbą", no_work_this_week: "Šią savaitę darbų nėra",
      monday: "Pirmadienis", tuesday: "Antradienis", wednesday: "Trečiadienis", thursday: "Ketvirtadienis", friday: "Penktadienis", saturday: "Šeštadienis", sunday: "Sekmadienis",
      days: { Mo: "Pr", Di: "An", Mi: "Tr", Do: "Kt", Fr: "Pn", Sa: "Še", So: "Se" },
      client: "Užsakovas", address: "Adresas", contact_person: "Kontaktinis asmuo", contact: "Kontaktas", accommodation: "Nakvynė", phone: "Telefonas",
      transport: "Transport", comment: "Komentaras", employees: "Darbuotojai",
      documents: "Dokumentai", photos: "Nuotraukos", chat: "Chat", library: "Biblioteka", warehouse: "Sandėlis",
      company_documents: "Įmonės dokumentai", company_docs_desc: "Taisyklės, sutartys.", new_document: "Naujas dokumentas",
      documentName: "Dokumento pavadinimas", description: "Aprašymas", send_to_all: "Siųsti VISIEMS", require_signature: "Parašas būtinas",
      send: "Išsiųsti", all_workers: "Visiems", assigned_to: "Skirta", signed_count: "Pasirašė", doc_count: "dok.",
      addDocument: "Pridėti dokumentą", signatures: "Parašai", no_signatures: "Nėra parašų.", no_file_preview: "Nėra peržiūros.",
      admin_dashboard: "Pagrindinis", acts: "Aktai", maps: "Žemėlapiai", fahrtenbuch: "Kelionės", settings: "Nustatymai",
      live_location: "LIVE LOKACIJA", history: "Istorija", map_streets: "Gatvės", map_satellite: "Satelitas", waiting: "Laukiama",
      workerInfo: "Darbuotojo informacija", name: "Vardas", email: "El. paštas", loginCode: "Prisijungimo kodas", codeUsed: "Panaudotas", codeActive: "Aktyvus",
      noDocuments: "Nėra dokumentų.", uploadDocument: "Įkelti dokumentą", regenerate: "Generuoti", copy: "Kopijuoti",
      
      /* --- BIOMETRIJA (NAUJA) --- */
      face_id: "Face ID", fingerprint: "Atspaudas", language: "Kalba", failed_faceid: "Nepavyko",
      failed_fingerprint: "Nepavyko", too_many_attempts: "Per daug bandymų.",
      biometric_title: "Biometrinis prisijungimas",
      biometric_subtitle: "Skenuokite pirštą arba veidą",
      biometric_description: "Patvirtinkite savo tapatybę",
      biometrics_not_supported: "Biometrija nepalaikoma šiame įrenginyje.",

      kw: "sav.", no_projects: "Projektų nerasta.", select_project_error: "Pasirinkite objektą!",
      confirm_end_work: "Baigti darbą?", work: "Darbas", off: "Laisvadienis", sick: "Serga", vacation: "Atostogos", holiday: "Šventė",
      select_status: "Pasirinkti statusą", create_and_send: "Sukurti ir siųsti", sending: "Siunčiama...", sent: "Išsiūsta",
      sent_projects: "Išsiųsti projektai", sureDelete: "Ištrinti?", error_no_workers: "Nėra dirbančių darbuotojų!",
      conflict_warning: "{{name}} jau priskirtas prie „{{project}}“ ({{day}}). Priskirti ir čia?",
      addWorker: "Pridėti darbuotoją", code_copied: "Kodas nukopijuotas!", confirm_regenerate_code: "Generuoti naują kodą?",
      v11_feature_alert: "Bus 1.1 versijoje", live_gps: "Gyvas GPS", no_gps: "Nėra GPS",
      rules_work_hours: "Taisyklės", rule_actual_time: "Faktinis laikas", rule_no_overtime: "Be viršvalandžių",
      rule_manual_adj: "Admin korekcijos", rule_exported_data: "Pakoreguoti duomenys", rules_break_auto: "Pertraukos",
      rule_break_up_to_6h: "6val -> 30min", rule_break_more_6h: "6val+ -> 60min", rule_break_auto_applied: "Auto pertrauka",
      important_notice: "Svarbu", legal_disclaimer: "Admin atsakomybė.",
      total: "VISO", month: "Mėnuo", netto: "Netto", email_subject: "Ataskaita", email_greeting: "Sveiki", email_body_text: "Siunčiu apskaitą už",
      error_title_required: "Įveskite pavadinimą!", error_select_worker: "Pasirinkite darbuotojus!", sending_success: "Išsiųsta!",
      protocol_title: "PARAŠŲ PROTOKOLAS", document_label: "Dokumentas", created_at: "Sukurta", original_file: "Failas",
      file_link: "Nuoroda", click_to_open: "Atidaryti", signatures_section: "PARAŠAI", signed_name: "Vardas", signed_date: "Data",
      timesheet_title: "Darbo laiko apskaitos žiniaraštis", company: "Įmonė",
      error_missing_project_info: "Pirma suveskite objektą!",
      weekly_plan_pdf: "Savaitės planas PDF", search_and_filter: "Ieškoti / Filtruoti...", search_tooltip_hint: "Filtruokite", print_pdf: "PDF / SPAUSDINTI",
      project_info: "Projekto Info", no_projects_found: "Projektų nerasta.", copy_to_another_kw: "Kopijuoti info į kitą savaitę",
      select_kw: "PASIRINKTI SAVAITĘ", with_workers: "Su darbuotojais", copy_to_kw: "PERKELTI Į KITĄ SAVAITĘ",
      cancel_edit: "ATŠAUKTI REDAGAVIMĄ", no_changes: "Pakeitimų nerasta.", data_saved: "Duomenys išsaugoti!",
      custom_status_warning: "Dėmesio statusas", new_status_placeholder: "Naujas statusas...",
      duplicate_worker_error: "Darbuotojas jau egzistuoja!", add_custom_field: "Pridėti lauką",
      field_name: "Pavadinimas", field_value: "Reikšmė", upload_docs_label: "Dokumentai", upload_btn: "Įkelti",
      selected_files: "Failai:", error_saving: "Klaida: ", editing: "Redaguojama", update: "Atnaujinti",
      project_budget: "Projekto Biudžetas", sum: "Suma", add_line: "Pridėti eilutę", example_desc: "Pvz. Betonavimas...",
      project_value: "Projekto vertė", plan_budget: "Planuoti biudžetą", new_project: "Naujas projektas", quantity: "Kiekis", unit: "Vnt.", price: "Kaina",
      attention: "Dėmesio", no_new_changes: "Naujų pakeitimų nerasta.",
      export_mode: "EKSPORTO REŽIMAS", export: "EKSPORTUOTI", category: "Kategorija", additional_info: "Papildoma info", add_field: "Pridėti lauką",
      view: "Peržiūrėti", remove_from_project: "Pašalinti iš projekto", car: "Automobilis", hotel: "Nakvynė", admin: "Admin",
      pdf_print: "PDF / Spausdinti", date: "Data", company_profile: "Įmonės profilis", edit_profile: "Redaguoti profilį",
      company_name: "Įmonės pavadinimas", vat_id: "Įmonės kodas", phone_number: "Telefonas", street_and_number: "Gatvė",
      postal_code: "Pasto kodas", city: "Miestas", work_email: "Darbo el. paštas", cancel_changes: "Atšaukti",
      team_management: "Komanda", locked: "Užrakinta", password: "Slaptažodis", add_sub_admin: "Pridėti vadybininką",
      generate_access: "Generuoti prieigą", plan_and_limits: "Planas ir limitai", upgrade: "Atnaujinti",
      worker_limit: "Darbuotojų limitas", admin_limit: "Adminų limitas", read_only: "Tik skaitymui", limit_reached: "Limitai pasiekti!",
      error_name_required: "Vardas privalomas!",
      draw_signature: "Pasirašykite čia:",
      clear: "Išvalyti",
      confirm_signature: "Patvirtinti parašą",
      please_sign: "Prašome pasirašyti (langelis tuščias).",
      confirm_sign_doc: "Ar tikrai norite pasirašyti ir išsiųsti?",
      signed_successfully: "Sėkmingai pasirašyta!",
      sign_document: "Pasirašyti",
      open_file: "Atidaryti failą",
      signed: "Pasirašyta",
      your_signature: "Jūsų parašas",
      signature: "Parašas",
      tap_to_sign: "Paspauskite, kad pasirašytumėte",
      archive: "Archyvas",
      archive_description: "Čia esantys darbuotojai neužima plano vietų.",
      back_to_list: "Atgal į sąrašą",
      restore: "Grąžinti į darbą",
      delete_permanently: "Ištrinti visam laikui",
      restore_confirm: "Ar tikrai norite grąžinti į aktyvų sąrašą:",
      delete_permanent_confirm: "DĖMESIO! Tai negrįžtamai ištrins darbuotoją ir visą jo istoriją. Tęsti?",
      restore_limit_error: "Negalima atstatyti! Pasiektas plano limitas.",
      archive_empty: "Archyvas tuščias",
      archive_worker_confirm: "Archyvuoti darbuotoją?",
      archive_worker_desc: "Šis darbuotojas bus perkeltas į archyvą. Jo istorija išliks, o vieta plane atsilaisvins.",
      photo_report_title: "FOTO ATASKAITA",
      photo_num: "Foto",
      no_photos_yet: "Nuotraukų dar nėra",
      add_photo: "Pridėti nuotrauką",
      general_comment_uppercase: "BENDRI KOMENTARAI",
      general_comment: "Bendras komentaras",
      worker_signature: "Darbuotojo parašas",
      client_signature: "Parašas (Klientas / Kita)",
      verified_by: "Patvirtino / Parašas",
      save_offline_btn: "Saugoti (Offline)",
      send_btn: "Siųsti",
      sent_success: "Išsiųsta!",
      share: "Dalintis",
      empty_history: "Tuščia",
      photo_comment_placeholder: "Komentaras...",
      reports_title: "Ataskaitos",
      no_photos_in_record: "Šiame įraše nėra nuotraukų.",
      generated_by_system: "Sugeneruota BuildForce AL",
      no_comment: "Be komentaro",
      status_viewed: "Peržiūrėta",
      status_new: "Naujas",
      status_completed: "Atlikta",
      view_all: "Žiūrėti visus",
      no_date: "Nėra datos",
      generating: "Generuojama...",
      download_pdf: "Atsisiųsti PDF",
      no_reports: "Ataskaitų nerasta.",
      unknown_worker: "Nežinomas",
      unknown_project: "Nežinomas",
      confirm_delete: "Ar tikrai norite ištrinti?",
      no_info: "Nėra info",

      /* --- NAUJI (PROFILE & SHARE) --- */
      profile: "Profilis",
      personal_data: "Asmeniniai duomenys",
      data_managed_by_admin: "Duomenis valdo administratorius.",
      shared_success: "Pasidalinta",
      error_sending_failed: "Išsiųsti nepavyko",
      share_error: "Pasidalinti nepavyko"
    }
  },

  ru: {
    translation: {
      back: "Назад", close: "Закрыть", save: "Сохранить", cancel: "Отмена", delete: "Удалить", edit: "Изменить", info: "Инфо", actions: "Действия",
      search: "Поиск", uploadFile: "Загрузить", loading: "Загрузка...", login: "Войти", logout: "Выйти",
      workHours: "Часы", worker: "Сотрудник", workers: "Сотрудники", no_workers: "Нет сотрудников.", open: "Открыть", day: "День",
      workStart: "Старт", workEnd: "Конец", breakTime: "Перерыв", project: "Проект", projects: "Проекты", other: "Другое",
      add_column: "Добавить", total_netto: "ИТОГО", email_open: "Почта открыта.", saved: "Сохранено!", error: "Ошибка.",
      weekly_plan: "План недели", start_work: "Начать работу", no_work_this_week: "Нет работы",
      monday: "Понедельник", tuesday: "Вторник", wednesday: "Среда", thursday: "Четверг", friday: "Пятница", saturday: "Суббота", sunday: "Воскресенье",
      days: { Mo: "Пн", Di: "Вт", Mi: "Ср", Do: "Чт", Fr: "Пт", Sa: "Сб", So: "Вс" },
      client: "Заказчик", address: "Адрес", contact_person: "Контакт", contact: "Связь", accommodation: "Жилье", phone: "Тел",
      transport: "Транспорт", comment: "Комент", employees: "Сотрудники",
      documents: "Доки", photos: "Фото", chat: "Чат", library: "Библиотека", warehouse: "Склад",
      company_documents: "Доки фирмы", company_docs_desc: "Правила.", new_document: "Новый док",
      documentName: "Название", description: "Описание", send_to_all: "Всем", require_signature: "Подпись",
      send: "Послать", all_workers: "Все", assigned_to: "Назначен", signed_count: "Подписано", doc_count: "док.",
      addDocument: "Добавить док", signatures: "Подписи", no_signatures: "Нет подписей.", no_file_preview: "Нет превью.",
      admin_dashboard: "Панель", acts: "Акты", maps: "Карта", fahrtenbuch: "Журнал", settings: "Настройки",
      live_location: "ЛОКАЦИЯ", history: "История", map_streets: "Улицы", map_satellite: "Спутник", waiting: "Ожидание",
      workerInfo: "Инфо", name: "Имя", email: "E-mail", loginCode: "Код", codeUsed: "Использован", codeActive: "Активен",
      noDocuments: "Нет доков.", uploadDocument: "Загрузить", regenerate: "Новый код", copy: "Копировать",
      
      /* --- BIOMETRIJA (NAUJA) --- */
      face_id: "Face ID", fingerprint: "Отпечатък", language: "Язык", failed_faceid: "Ошибка",
      failed_fingerprint: "Ошибка", too_many_attempts: "Много попыток.",
      biometric_title: "Биометрический вход",
      biometric_subtitle: "Сканируйте палец или лицо",
      biometric_description: "Подтвердите свою личность",
      biometrics_not_supported: "Биометрия не поддерживается.",

      kw: "кв", no_projects: "Проекты не найдены.", select_project_error: "Выберите проект!",
      confirm_end_work: "Закончить?", work: "Работа", off: "Выходной", sick: "Болен", vacation: "Отпуск", holiday: "Празник",
      select_status: "Статус", create_and_send: "Создать и послать", sending: "Отправка...", sent: "Послано",
      sent_projects: "Проекты", sureDelete: "Удалить?", error_no_workers: "Нет сотрудников!",
      conflict_warning: "{{name}} уже назначен на '{{project}}' ({{day}}). Назначить и сюда?",
      addWorker: "Добавить сотрудника", code_copied: "Код скопирован!", confirm_regenerate_code: "Новый код?",
      v11_feature_alert: "Будет в v1.1", live_gps: "Живой GPS", no_gps: "Нет GPS",
      rules_work_hours: "Правила", rule_actual_time: "Фактическое время", rule_no_overtime: "Без сверхурочных",
      rule_manual_adj: "Коррекция админом", rule_exported_data: "Итоговые значения", rules_break_auto: "Перерывы",
      rule_break_up_to_6h: "6ч -> 30min", rule_break_more_6h: "6ч+ -> 60min", rule_break_auto_applied: "Авто-перерыв",
      important_notice: "Важно", legal_disclaimer: "Ответственность админа.",
      total: "ИТОГО", month: "Месяц", netto: "Netto", email_subject: "Отчет", email_greeting: "Здравствуйте", email_body_text: "Высылаю отчет за",
      error_title_required: "Введите название!", error_select_worker: "Выберите сотрудников!", sending_success: "Отправлено!",
      protocol_title: "ПРОТОКОЛ ПОДПИСЕЙ", document_label: "Документ", created_at: "Создано", original_file: "Файл",
      file_link: "Ссылка", click_to_open: "Открыть", signatures_section: "ПОДПИСИ", signed_name: "Имя", signed_date: "Дата",
      timesheet_title: "Табель учета рабочего времени", company: "Компания",
      error_missing_project_info: "Введите данные объекта!",
      weekly_plan_pdf: "Недельный план PDF", search_and_filter: "Поиск / Фильтр...", search_tooltip_hint: "Фильтр", print_pdf: "ПЕЧАТЬ / PDF",
      project_info: "Инфо проекта", no_projects_found: "Проекты не найдены.", copy_to_another_kw: "Копировать на др. неделю",
      select_kw: "ВЫБРАТЬ НЕДЕЛЮ", with_workers: "С сотрудниками", copy_to_kw: "ПЕРЕНЕСТИ",
      cancel_edit: "ОТМЕНИТЬ РЕДАКТИРОВАНИЕ", no_changes: "Нет изменений.", data_saved: "Сохранено!",
      custom_status_warning: "Внимание статус", new_status_placeholder: "Имя статуса...",
      duplicate_worker_error: "Сотрудник уже существует!", add_custom_field: "Добавить поле",
      field_name: "Название поля", field_value: "Значение", upload_docs_label: "Документы", upload_btn: "Загрузить",
      selected_files: "Выбрано:", error_saving: "Ошибка: ", editing: "Редактирование", update: "Обновить",
      project_budget: "Бюджет проекта", sum: "Сумма", add_line: "Добавить строку", example_desc: "Напр. Бетон...",
      project_value: "Стоимость проекта", plan_budget: "Планировать бюджет", new_project: "Новый проект", quantity: "Кол-во", unit: "Ед.", price: "Цена",
      attention: "Внимание", no_new_changes: "Новых изменений не найдено.",
      export_mode: "РЕЖИМ ЭКСПОРТ", export: "ЭКСПОРТ", category: "Категория", additional_info: "Доп. инфо", add_field: "Добавить поле",
      view: "Просмотр", remove_from_project: "Удалить из проекта", car: "Авто", hotel: "Отель", admin: "Админ",
      pdf_print: "PDF / Печать", date: "Дата", company_profile: "Профиль компании", edit_profile: "Изменить профиль",
      company_name: "Название компании", vat_id: "Код компании", phone_number: "Телефон", street_and_number: "Улица",
      postal_code: "Почтовый индекс", city: "Город", work_email: "Рабочий email", cancel_changes: "Отмена изменений",
      team_management: "Команда", locked: "Заблокирован", password: "Пароль", add_sub_admin: "Добавить админа",
      generate_access: "Создать доступ", plan_and_limits: "План и лимиты", upgrade: "Обновить",
      worker_limit: "Лимит сотрудников", admin_limit: "Лимит админов", read_only: "Только чтение", limit_reached: "Лимит исчерпан!",
      error_name_required: "Имя обязательно!",
      draw_signature: "Подпишите здесь:",
      clear: "Очистить",
      confirm_signature: "Подтвердить подпись",
      please_sign: "Пожалуйста, поставьте подпись.",
      confirm_sign_doc: "Вы действительно хотите подписать и отправить?",
      signed_successfully: "Успешно подписано!",
      sign_document: "Подписать",
      open_file: "Открыть файл",
      signed: "Подписано",
      your_signature: "Ваша подпись",
      signature: "Подпись",
      tap_to_sign: "Нажмите, чтобы подписать",
      archive: "Архив",
      archive_description: "Сотрудники здесь не занимают места в плане.",
      back_to_list: "Назад к списку",
      restore: "Восстановить",
      delete_permanently: "Удалить навсегда",
      restore_confirm: "Вы уверены, что хотите восстановить:",
      delete_permanent_confirm: "ВНИМАНИЕ! Это навсегда удалит сотрудника и его историю. Продолжить?",
      restore_limit_error: "Невозможно восстановить! Лимит плана достигнут.",
      archive_empty: "Архив пуст",
      archive_worker_confirm: "Архивировать сотрудника?",
      archive_worker_desc: "Сотрудник будет перемещен в архив. История сохранится, место в плане освободится.",
      photo_report_title: "ФОТООТЧЕТ",
      photo_num: "Фото",
      no_photos_yet: "Нет фото",
      add_photo: "Добавить фото",
      general_comment_uppercase: "ОБЩИЕ КОММЕНТАРИИ",
      general_comment: "Общий комментарий",
      worker_signature: "Подпись сотрудника",
      client_signature: "Подпись (Клиент / Другое)",
      verified_by: "Подтвердил / Подпись",
      save_offline_btn: "Сохранить (Офлайн)",
      send_btn: "Отправить",
      sent_success: "Отправлено!",
      share: "Поделиться",
      empty_history: "Пусто",
      photo_comment_placeholder: "Комментарий...",
      reports_title: "Отчеты",
      no_photos_in_record: "Нет фото в этой записи.",
      generated_by_system: "Сгенерировано BuildForce AL",
      no_comment: "Нет комментариев",
      status_viewed: "Просмотрено",
      status_new: "Новый",
      status_completed: "Готово",
      view_all: "Смотреть все",
      no_date: "Нет даты",
      generating: "Генерация...",
      download_pdf: "Скачать PDF",
      no_reports: "Отчеты не найдены.",
      unknown_worker: "Неизвестно",
      unknown_project: "Неизвестно",
      confirm_delete: "Вы уверены, что хотите удалить?",
      no_info: "Нет инфо",

      /* --- NAUJI (PROFILE & SHARE) --- */
      profile: "Профиль",
      personal_data: "Личные данные",
      data_managed_by_admin: "Данные управляются администратором.",
      shared_success: "Поделились",
      error_sending_failed: "Ошибка отправки",
      share_error: "Ошибка при попытке поделиться"
    }
  },

  ro: {
    translation: {
      back: "Înapoi", close: "Închide", save: "Salvează", cancel: "Anulează", delete: "Șterge", edit: "Editează", info: "Info", actions: "Acțiuni",
      search: "Căutare", uploadFile: "Încarcă", loading: "Se încarcă...", login: "Login", logout: "Logout",
      workHours: "Ore muncă", worker: "Angajat", workers: "Angajați", no_workers: "Niciun angajat.", open: "Deschide", day: "Zi",
      workStart: "Start", workEnd: "Sfârșit", breakTime: "Pauză", project: "Proiect", projects: "Proiecte", other: "Alte",
      add_column: "Adaugă coloană", total_netto: "Total Netto", email_open: "Email deschis.", saved: "Salvat!", error: "Eroare.",
      weekly_plan: "Plan săptămânal", start_work: "Începe munca", no_work_this_week: "Fără muncă",
      monday: "Luni", tuesday: "Marți", wednesday: "Miercuri", thursday: "Joi", friday: "Vineri", saturday: "Sâmbătă", sunday: "Duminică",
      days: { Mo: "Lu", Di: "Ma", Mi: "Mi", Do: "Jo", Fr: "Vi", Sa: "Sâ", So: "Du" },
      client: "Client", address: "Adresă", contact_person: "Persoană contact", contact: "Contact", accommodation: "Cazare", phone: "Tel",
      transport: "Transport", comment: "Comentariu", employees: "Angajați",
      documents: "Documente", photos: "Poze", chat: "Chat", library: "Bibliotecă", warehouse: "Depozit",
      company_documents: "Documente firmă", company_docs_desc: "Reguli.", new_document: "Document nou",
      documentName: "Nume", description: "Descriere", send_to_all: "La toți", require_signature: "Semnătură",
      send: "Trimite", all_workers: "Toți", assigned_to: "Alocat", signed_count: "Semnat", doc_count: "doc.",
      addDocument: "Adaugă doc", signatures: "Semnături", no_signatures: "Fără semnături.", no_file_preview: "Fără previzualizare.",
      admin_dashboard: "Panou", acts: "Acte", maps: "Hărți", fahrtenbuch: "Jurnal", settings: "Setări",
      live_location: "Locație LIVE", history: "Istoric", map_streets: "Străzi", map_satellite: "Satelit", waiting: "Așteptare",
      workerInfo: "Info angajat", name: "Nume", email: "Email", loginCode: "Cod", codeUsed: "Folosit", codeActive: "Activ",
      noDocuments: "Fără doc.", uploadDocument: "Încarcă", regenerate: "Regenerare", copy: "Copiază",
      
      /* --- BIOMETRIJA (NAUJA) --- */
      face_id: "Face ID", fingerprint: "Amprentă", language: "Limbă", failed_faceid: "Eșuat",
      failed_fingerprint: "Eșuat", too_many_attempts: "Prea multe încercări.",
      biometric_title: "Autentificare biometrică",
      biometric_subtitle: "Scanați fața / amprenta",
      biometric_description: "Confirmați identitatea",
      biometrics_not_supported: "Biometria nu este acceptată.",

      kw: "săpt.", no_projects: "Niciun proiect găsit.", select_project_error: "Selectați proiectul!",
      confirm_end_work: "Sfârșit?", work: "Muncă", off: "Liber", sick: "Bolnav", vacation: "Concediu", holiday: "Sărbătoare",
      select_status: "Status", create_and_send: "Trimite", sending: "Se trimite...", sent: "Trimis",
      sent_projects: "Proiecte", sureDelete: "Șterge?", error_no_workers: "Niciun angajat la muncă!",
      conflict_warning: "{{name}} este deja alocat la '{{project}}' ({{day}}). Îl alocați și aici?",
      addWorker: "Adaugă angajat", code_copied: "Cod copiat!", confirm_regenerate_code: "Cod nou?",
      v11_feature_alert: "În v1.1", live_gps: "GPS Live", no_gps: "Fără GPS",
      rules_work_hours: "Reguli ore", rule_actual_time: "Timp real", rule_no_overtime: "Fără ore suplim.",
      rule_manual_adj: "Ajustare manuală", rule_exported_data: "Valori finale", rules_break_auto: "Pauză",
      rule_break_up_to_6h: "6h -> 30min", rule_break_more_6h: "6h+ -> 60min", rule_break_auto_applied: "Pauză automată",
      important_notice: "Important", legal_disclaimer: "Responsabilitate admin.",
      total: "TOTAL", month: "Lună", netto: "Netto", email_subject: "Raport ore", email_greeting: "Bună ziua", email_body_text: "Trimit raportul pentru",
      error_title_required: "Titlu obligatoriu!", error_select_worker: "Selectați angajatul!", sending_success: "Trimis!",
      protocol_title: "PROTOCOL SEMNĂTURI", document_label: "Document", created_at: "Creat la", original_file: "Fișier",
      file_link: "Link", click_to_open: "Click pentru deschidere", signatures_section: "SEMNĂTURI", signed_name: "Nume", signed_date: "Data",
      timesheet_title: "Foaie de prezență", company: "Companie",
      error_missing_project_info: "Introduceți detalii!",
      weekly_plan_pdf: "Plan săptămânal PDF", search_and_filter: "Căutare / Filtrare...", search_tooltip_hint: "Filtru", print_pdf: "IMPRIMARE / PDF",
      project_info: "Info Proiect", no_projects_found: "Niciun proiect găsit.", copy_to_another_kw: "Copiați în altă săpt.",
      select_kw: "SELECTAȚI SĂPTĂMÂNA", with_workers: "Cu angajați", copy_to_kw: "COPIAZĂ ÎN ALTĂ SĂPTĂMÂNĂ",
      cancel_edit: "ANULEAZĂ EDITAREA", no_changes: "Nicio modificare.", data_saved: "Date salvate!",
      custom_status_warning: "Status personalizat", new_status_placeholder: "Nume status...",
      duplicate_worker_error: "Angajatul există deja!", add_custom_field: "Adaugă câmp",
      field_name: "Nume câmp", field_value: "Valoare", upload_docs_label: "Documente", upload_btn: "Încarcă",
      selected_files: "Fișiere:", error_saving: "Eroare: ", editing: "Editare", update: "Actualizare",
      project_budget: "Buget Proiect", sum: "Sumă", add_line: "Adaugă rând", example_desc: "Ex. Beton...",
      project_value: "Valoare Proiect", plan_budget: "Planificare buget", new_project: "Proiect Nou", quantity: "Cant.", unit: "Unit.", price: "Preț",
      attention: "Atenție", no_new_changes: "Nu s-au găsit modificări noi.",
      export_mode: "MOD EXPORT", export: "EXPORT", category: "Categorie", additional_info: "Info suplimentare", add_field: "Adaugă câmp",
      view: "Vizualizare", remove_from_project: "Eliminați din proiect", car: "Mașină", hotel: "Cazare", admin: "Admin",
      pdf_print: "PDF / Imprimare", date: "Data", company_profile: "Profil companie", edit_profile: "Editează profilul",
      company_name: "Nume companie", vat_id: "Cod companie", phone_number: "Telefon", street_and_number: "Stradă",
      postal_code: "Cod poștal", city: "Oraș", work_email: "Email serviciu", cancel_changes: "Anulează modificările",
      team_management: "Echipă", locked: "Blocat", password: "Parolă", add_sub_admin: "Adaugă admin",
      generate_access: "Generează acces", plan_and_limits: "Plan și limite", upgrade: "Actualizare",
      worker_limit: "Limită angajați", admin_limit: "Limită admini", read_only: "Doar citire", limit_reached: "Limita atinsă!",
      error_name_required: "Numele este obligatoriu!",
      draw_signature: "Semnați aici:",
      clear: "Șterge",
      confirm_signature: "Confirmă semnătura",
      please_sign: "Vă rugăm să semnați.",
      confirm_sign_doc: "Sigur doriți să semnați și să trimiteți?",
      signed_successfully: "Semnat cu succes!",
      sign_document: "Semnează",
      open_file: "Deschide fișierul",
      signed: "Semnat",
      your_signature: "Semnătura dvs.",
      signature: "Semnătură",
      tap_to_sign: "Atingeți pentru a semna",
      archive: "Arhivă",
      archive_description: "Angajații de aici nu ocupă locuri în plan.",
      back_to_list: "Înapoi la listă",
      restore: "Restabilește",
      delete_permanently: "Șterge definitiv",
      restore_confirm: "Sigur doriți să restabiliți:",
      delete_permanent_confirm: "ATENȚIE! Aceasta va șterge definitiv angajatul și istoricul. Continuați?",
      restore_limit_error: "Nu se poate restabili! Limită plan atinsă.",
      archive_empty: "Arhiva este goală",
      archive_worker_confirm: "Arhivați angajatul?",
      archive_worker_desc: "Angajatul va fi mutat în arhivă. Istoricul se păstrează, locul în plan se eliberează.",
      photo_report_title: "RAPORT FOTO",
      photo_num: "Foto",
      no_photos_yet: "Încă nu sunt poze",
      add_photo: "Adaugă poză",
      general_comment_uppercase: "COMENTARII GENERALE",
      general_comment: "Comentariu general",
      worker_signature: "Semnătura angajatului",
      client_signature: "Semnătură (Client / Altele)",
      verified_by: "Verificat de / Semnătură",
      save_offline_btn: "Salvează (Offline)",
      send_btn: "Trimite",
      sent_success: "Trimis!",
      share: "Partajează",
      empty_history: "Gol",
      photo_comment_placeholder: "Comentariu...",
      reports_title: "Rapoarte",
      no_photos_in_record: "Fără poze în această înregistrare.",
      generated_by_system: "Generat de BuildForce AL",
      no_comment: "Fără comentariu",
      status_viewed: "Vizualizat",
      status_new: "Nou",
      status_completed: "Finalizat",
      view_all: "Vezi tot",
      no_date: "Fără dată",
      generating: "Se generează...",
      download_pdf: "Descarcă PDF",
      no_reports: "Nu s-au găsit rapoarte.",
      unknown_worker: "Necunoscut",
      unknown_project: "Necunoscut",
      confirm_delete: "Sigur doriți să ștergeți?",
      no_info: "Fără info",

      /* --- NAUJI (PROFILE & SHARE) --- */
      profile: "Profil",
      personal_data: "Date personale",
      data_managed_by_admin: "Datele sunt gestionate de administrator.",
      shared_success: "Partajat",
      error_sending_failed: "Trimitere eșuată",
      share_error: "Partajare eșuată"
    }
  },

  bg: {
    translation: {
      back: "Назад", close: "Затвори", save: "Запази", cancel: "Отказ", delete: "Изтрий", edit: "Редактирай", info: "Инфо", actions: "Действия",
      search: "Търсене", uploadFile: "Качи", loading: "Зареждане...", login: "Вход", logout: "Изход",
      workHours: "Часове", worker: "Служител", workers: "Служители", no_workers: "Няма служители.", open: "Отвори", day: "Ден",
      workStart: "Старт", workEnd: "Край", breakTime: "Почивка", project: "Проект", projects: "Проекти", other: "Други",
      add_column: "Колона", total_netto: "Общо", email_open: "Имейл отворен.", saved: "Запазено!", error: "Грешка.",
      weekly_plan: "Седмичен план", start_work: "Започни работа", no_work_this_week: "Няма работа",
      monday: "Понедельник", tuesday: "Вторник", wednesday: "Среда", thursday: "Четвъртък", friday: "Петък", saturday: "Събота", sunday: "Неделя",
      days: { Mo: "Пн", Di: "Вт", Mi: "Ср", Do: "Чт", Fr: "Пт", Sa: "Сб", So: "Нд" },
      client: "Клиент", address: "Адрес", contact_person: "Контакт", contact: "Връзка", accommodation: "Настаняване", phone: "Тел",
      transport: "Транспорт", comment: "Коментар", employees: "Служители",
      documents: "Документи", photos: "Снимки", chat: "Чат", library: "Библиотека", warehouse: "Склад",
      company_documents: "Фирмени док.", company_docs_desc: "Правила.", new_document: "Нов док",
      documentName: "Име", description: "Описание", send_to_all: "До всички", require_signature: "Подпис",
      send: "Изпрати", all_workers: "Всички", assigned_to: "Назначен", signed_count: "Подписано", doc_count: "док.",
      addDocument: "Добави док", signatures: "Подписи", no_signatures: "Няма подписи.", no_file_preview: "Няма преглед.",
      admin_dashboard: "Табло", acts: "Актове", maps: "Карти", fahrtenbuch: "Дневник", settings: "Настройки",
      live_location: "ЛОКАЦИЯ", history: "История", map_streets: "Улици", map_satellite: "Сателит", waiting: "Чакане",
      workerInfo: "Инфо", name: "Име", email: "Имейл", loginCode: "Код", codeUsed: "Използван", codeActive: "Активен",
      noDocuments: "Няма док.", uploadDocument: "Качи", regenerate: "Нов код", copy: "Копирай",
      
      /* --- BIOMETRIJA (NAUJA) --- */
      face_id: "Face ID", fingerprint: "Отпечатък", language: "Език", failed_faceid: "Неуспешно",
      failed_fingerprint: "Неуспешно", too_many_attempts: "Много опити.",
      biometric_title: "Биометричен вход",
      biometric_subtitle: "Сканирайте лице или пръст",
      biometric_description: "Потвърдете самоличността си",
      biometrics_not_supported: "Биометрията не се поддържа.",

      kw: "седм.", no_projects: "Няма намерени проекти.", select_project_error: "Изберете проект!",
      confirm_end_work: "Край?", work: "Работа", off: "Почивка", sick: "Болен", vacation: "Отпуск", holiday: "Празник",
      select_status: "Статус", create_and_send: "Изпрати", sending: "Изпращане...", sent: "Изпратено",
      sent_projects: "Проекти", sureDelete: "Изтрий?", error_no_workers: "Няма служители на работа!",
      conflict_warning: "{{name}} вече е назначен към '{{project}}' ({{day}}). Да бъде ли назначен и тук?",
      addWorker: "Добави служител", code_copied: "Копирано!", confirm_regenerate_code: "Нов код?",
      v11_feature_alert: "Във v1.1", live_gps: "GPS на живо", no_gps: "Няма GPS",
      rules_work_hours: "Правила часове", rule_actual_time: "Действително време", rule_no_overtime: "Без извънр. труд",
      rule_manual_adj: "Ръчна корекция", rule_exported_data: "Финални данные", rules_break_auto: "Почивка",
      rule_break_up_to_6h: "6ч -> 30min", rule_break_more_6h: "6ч+ -> 60min", rule_break_auto_applied: "Автом. почивка",
      important_notice: "Важно", legal_disclaimer: "Админ отговорност.",
      total: "Общо", month: "Месец", netto: "Netto", email_subject: "Отчет за часове", email_greeting: "Здравейте", email_body_text: "Изпращам отчет за",
      error_title_required: "Заглавието е задължително!", error_select_worker: "Изберете служител!", sending_success: "Изпратено!",
      protocol_title: "ПРОТОКОЛ ЗА ПОДПИСИ", document_label: "Документ", created_at: "Създаден на", original_file: "Файл",
      file_link: "Връзка", click_to_open: "Отвори", signatures_section: "ПОДПИСИ", signed_name: "Име", signed_date: "Дата",
      timesheet_title: "График за работно време", company: "Компания",
      error_missing_project_info: "Въведете проект!",
      weekly_plan_pdf: "Седмичен план PDF", search_and_filter: "Търсене / Филтър...", search_tooltip_hint: "Филтър", print_pdf: "ПЕЧАТ / PDF",
      project_info: "Проект Инфо", no_projects_found: "Няма намерени проекти.", copy_to_another_kw: "Копиране в друга седмица",
      select_kw: "ИЗБЕРЕТЕ СЕДМИЦА", with_workers: "С служители", copy_to_kw: "ПРЕМЕСТИ В ДРУГА СЕДМИЦА",
      cancel_edit: "ОТМЕНИ РЕДАКТИРОВАНИЕ", no_changes: "Няма промени.", data_saved: "Запазено!",
      custom_status_warning: "Персонализиран статус", new_status_placeholder: "Име на статус...",
      duplicate_worker_error: "Служителят вече съществува!", add_custom_field: "Добави поле",
      field_name: "Име на поле", field_value: "Стойност", upload_docs_label: "Документи", upload_btn: "Качи",
      selected_files: "Избрано:", error_saving: "Грешка: ", editing: "Редактиране", update: "Актуализация",
      project_budget: "Бюджет на проекта", sum: "Сума", add_line: "Добави ред", example_desc: "Напр. Покриви...",
      project_value: "Стойност на проекта", plan_budget: "Планирай бюджет", new_project: "Нов проект", quantity: "Кол-во", unit: "Ед.", price: "Цена",
      attention: "Внимание", no_new_changes: "Няма намерени нови промени.",
      export_mode: "РЕЖИМ ЕКСПОРТ", export: "ЕКСПОРТ", category: "Категория", additional_info: "Доп. инфо", add_field: "Добави поле",
      view: "Преглед", remove_from_project: "Премахване от проекта", car: "Кола", hotel: "Хотел", admin: "Админ",
      pdf_print: "PDF / Печат", date: "Дата", company_profile: "Фирмен профил", edit_profile: "Редактирай профила",
      company_name: "Име на фирмата", vat_id: "Булстат", phone_number: "Телефон", street_and_number: "Улица",
      postal_code: "Пощ. код", city: "Град", work_email: "Служебен имейл", cancel_changes: "Откажи промените",
      team_management: "Екип", locked: "Заключен", password: "Парола", add_sub_admin: "Добави админ",
      generate_access: "Генерирай достъп", plan_and_limits: "План и лимити", upgrade: "Надграждане",
      worker_limit: "Лимит служители", admin_limit: "Лимит админи", read_only: "Само четене", limit_reached: "Лимитът е достигнат!",
      error_name_required: "Името е задължително!",
      draw_signature: "Подпишете тук:",
      clear: "Изчисти",
      confirm_signature: "Потвърди подписа",
      please_sign: "Моля, подпишете.",
      confirm_sign_doc: "Наистина ли искате да подпишете и изпратите?",
      signed_successfully: "Успешно подписано!",
      sign_document: "Подпиши",
      open_file: "Отвори файл",
      signed: "Подписано",
      your_signature: "Вашият подпис",
      signature: "Подпис",
      tap_to_sign: "Натиснете за подпис",
      archive: "Архив",
      archive_description: "Служителите тук не заемат места в плана.",
      back_to_list: "Обратно към списъка",
      restore: "Възстанови",
      delete_permanently: "Изтрий завинаги",
      restore_confirm: "Сигурни ли сте, че искате да възстановите:",
      delete_permanent_confirm: "ВНИМАНИЕ! Това ще изтрие служителя и историята завинаги. Продължи?",
      restore_limit_error: "Не може да се възстанови! Лимитът е достигнат.",
      archive_empty: "Архивът е празен",
      archive_worker_confirm: "Архивирай служител?",
      archive_worker_desc: "Служителят ще бъде преместен в архива. Историята се пази, мястото в плана се освобождава.",
      photo_report_title: "ФОТО ОТЧЕТ",
      photo_num: "Фото",
      no_photos_yet: "Няма снимки",
      add_photo: "Добави снимка",
      general_comment_uppercase: "ОБЩИ КОМЕНТАРИ",
      general_comment: "Общ коментар",
      worker_signature: "Подпис на служителя",
      client_signature: "Подпис (Клиент / Другое)",
      verified_by: "Потвърдено от / Подпис",
      save_offline_btn: "Запази (Офлайн)",
      send_btn: "Изпрати",
      sent_success: "Изпратено!",
      share: "Сподели",
      empty_history: "Празно",
      photo_comment_placeholder: "Коментар...",
      reports_title: "Отчети",
      no_photos_in_record: "Няма снимки в този запис.",
      generated_by_system: "Генерирано от BuildForce AL",
      no_comment: "Без коментар",
      status_viewed: "Прегледано",
      status_new: "Нов",
      status_completed: "Завършено",
      view_all: "Виж всички",
      no_date: "Няма дата",
      generating: "Генериране...",
      download_pdf: "Изтегли PDF",
      no_reports: "Няма намерени отчети.",
      unknown_worker: "Неизвестен",
      unknown_project: "Неизвестен",
      confirm_delete: "Сигурни ли сте, че искате да изтриете?",
      no_info: "Няма инфо",

      /* --- NAUJI (PROFILE & SHARE) --- */
      profile: "Профил",
      personal_data: "Лични данни",
      data_managed_by_admin: "Данните се управляват от администратора.",
      shared_success: "Споделено",
      error_sending_failed: "Грешка при изпращане",
      share_error: "Грешка при споделяне"
    }
  },

  nl: {
    translation: {
      back: "Terug", close: "Sluiten", save: "Opslaan", cancel: "Annuleren", delete: "Verwijderen", edit: "Bewerken", info: "Info", actions: "Acties",
      search: "Zoeken", uploadFile: "Upload", loading: "Laden...", login: "Login", logout: "Logout",
      workHours: "Werkuren", worker: "Werknemer", workers: "Werknemers", no_workers: "Geen werknemers.", open: "Openen", day: "Dag",
      workStart: "Start", workEnd: "Einde", breakTime: "Pauze", project: "Project", projects: "Projecten", other: "Overige",
      add_column: "Kolom", total_netto: "Totaal Netto", email_open: "E-mail open.", saved: "Opgeslagen!", error: "Fout.",
      weekly_plan: "Weekplanning", start_work: "Start werk", no_work_this_week: "Geen werk deze week",
      monday: "Maandag", tuesday: "Dinsdag", wednesday: "Woensdag", thursday: "Donderdag", friday: "Vrijdag", saturday: "Zaterdag", sunday: "Zondag",
      days: { Mo: "Ma", Di: "Di", Mi: "Wo", Do: "Do", Fr: "Vr", Sa: "Za", So: "Zo" },
      client: "Klant", address: "Adres", contact_person: "Contactpersoon", contact: "Contact", accommodation: "Logies", phone: "Tel",
      transport: "Vervoer", comment: "Opmerking", employees: "Werknemers",
      documents: "Documents", photos: "Foto's", chat: "Chat", library: "Bibliotheek", warehouse: "Magazijn",
      company_documents: "Bedrijfsdocs", company_docs_desc: "Regels.", new_document: "Nieuw doc",
      documentName: "Naam", description: "Beschrijving", send_to_all: "Aan allen", require_signature: "Handtekening",
      send: "Verzenden", all_workers: "Allen", assigned_to: "Toegewezen", signed_count: "Getekend", doc_count: "doc.",
      addDocument: "Doc toevoegen", signatures: "Handtekeningen", no_signatures: "Geen handtekeningen.", no_file_preview: "Geen voorbeeld.",
      admin_dashboard: "Dashboard", acts: "Akten", maps: "Kaarten", fahrtenbuch: "Rittenboek", settings: "Instellingen",
      live_location: "LIVE locatie", history: "Historie", map_streets: "Straten", map_satellite: "Satelliet", waiting: "Wachten",
      workerInfo: "Info werknemer", name: "Naam", email: "E-mail", loginCode: "Code", codeUsed: "Gebruikt", codeActive: "Actief",
      noDocuments: "Geen docs.", uploadDocument: "Upload", regenerate: "Regenereren", copy: "Kopiëren",
      
      /* --- BIOMETRIJA (NAUJA) --- */
      face_id: "Face ID", fingerprint: "Vingerafdruk", language: "Taal", failed_faceid: "Mislukt",
      failed_fingerprint: "Mislukt", too_many_attempts: "Te veel pogingen.",
      biometric_title: "Biometrische login",
      biometric_subtitle: "Scan gezicht of vingerafdruk",
      biometric_description: "Bevestig uw identiteit",
      biometrics_not_supported: "Biometrie wordt niet ondersteund.",

      kw: "week", no_projects: "Geen projecten gevonden.", select_project_error: "Kies project!",
      confirm_end_work: "Eindigen?", work: "Werk", off: "Vrij", sick: "Ziek", vacation: "Vakantie", holiday: "Feestdag",
      select_status: "Status", create_and_send: "Verzenden", sending: "Verzenden...", sent: "Verzonden",
      sent_projects: "Projecten", sureDelete: "Wissen?", error_no_workers: "Geen werkende medewerkers!",
      conflict_warning: "{{name}} is al toegewezen aan '{{project}}' ({{day}}). Ook hier toewijzen?",
      addWorker: "Werknemer toevoegen", code_copied: "Gekopieerd!", confirm_regenerate_code: "Nieuwe code?",
      v11_feature_alert: "In v1.1", live_gps: "Live GPS", no_gps: "Geen GPS",
      rules_work_hours: "Werkuren regels", rule_actual_time: "Feitelijke tijd", rule_no_overtime: "Geen overwerk",
      rule_manual_adj: "Handmatige aanpas.", rule_exported_data: "Admin waarden", rules_break_auto: "Pauze",
      rule_break_up_to_6h: "6u -> 30min", rule_break_more_6h: "6u+ -> 60min", rule_break_auto_applied: "Auto-pauze",
      important_notice: "Belangrijk", legal_disclaimer: "Admin verantwoordel.",
      total: "TOTAAL", month: "Maand", netto: "Netto", email_subject: "Urenstaat", email_greeting: "Hallo", email_body_text: "Hierbij de staat voor",
      error_title_required: "Titel verplicht!", error_select_worker: "Kies medewerker!", sending_success: "Verzonden!",
      protocol_title: "HANDTEKENINGENPROTOCOL", document_label: "Document", created_at: "Gemaakt op", original_file: "Bestand",
      file_link: "Link", click_to_open: "Klik om te openen", signatures_section: "HANDTEKENINGEN", signed_name: "Naam", signed_date: "Datum",
      timesheet_title: "Tijdsregistratieoverzicht", company: "Bedrijf",
      error_missing_project_info: "Projectgegevens invoeren!",
      weekly_plan_pdf: "Weekplanning PDF", search_and_filter: "Zoeken / Filteren...", search_tooltip_hint: "Filter", print_pdf: "AFDRUKKEN / PDF",
      project_info: "Project Info", no_projects_found: "Geen projecten gevonden.", copy_to_another_kw: "Naar andere week kopiëren",
      select_kw: "SELECTEER WEEK", with_workers: "Met werknemers", copy_to_kw: "VERPLAATSEN NAAR ANDERE WEEK",
      cancel_edit: "BEWERKING ANNULEREN", no_changes: "Geen wijzigingen.", data_saved: "Gegevens opgeslagen!",
      custom_status_warning: "Aangepaste status", new_status_placeholder: "Naam status...",
      duplicate_worker_error: "Werknemer bestaat al!", add_custom_field: "Extra veld toevoegen",
      field_name: "Veldnaam", field_value: "Waarde", upload_docs_label: "Documenten", upload_btn: "Uploaden",
      selected_files: "Bestanden:", error_saving: "Fout: ", editing: "Bewerken", update: "Updaten",
      project_budget: "Projectbudget", sum: "Som", add_line: "Regel toevoegen", example_desc: "Bijv. Beton...",
      project_value: "Projectwaarde", plan_budget: "Budget plannen", new_project: "Nieuw project", quantity: "Aantal", unit: "Eenh.", price: "Prijs",
      attention: "Let op", no_new_changes: "Geen nieuwe wijzigingen gevonden.",
      export_mode: "EXPORTMODUS", export: "EXPORT", category: "Categorie", additional_info: "Extra info", add_field: "Veld toevoegen",
      view: "Bekijken", remove_from_project: "Verwijderen uit project", car: "Auto", hotel: "Hotel", admin: "Admin",
      pdf_print: "PDF / Afdrukken", date: "Datum", company_profile: "Bedrijfsprofiel", edit_profile: "Profiel bewerken",
      company_name: "Bedrijfsnaam", vat_id: "BTW-nummer", phone_number: "Telefoon", street_and_number: "Straat",
      postal_code: "Postcode", city: "Stad", work_email: "Werk-email", cancel_changes: "Annuleren", team_management: "Team",
      locked: "Gecblokkeerd", password: "Wachtwoord", add_sub_admin: "Admin toevoegen", generate_access: "Toegang genereren",
      plan_and_limits: "Plan & Limieten", upgrade: "Upgrade", worker_limit: "Werknemerslimiet", admin_limit: "Adminlimiet",
      read_only: "Alleen lezen", limit_reached: "Limiet bereikt!", error_name_required: "Naam verplicht!",
      draw_signature: "Teken hier:",
      clear: "Wissen",
      confirm_signature: "Handtekening bevestigen",
      please_sign: "Graag eerst tekenen.",
      confirm_sign_doc: "Wilt u dit document echt ondertekenen en verzenden?",
      signed_successfully: "Succesvol ondertekend!",
      sign_document: "Ondertekenen",
      open_file: "Bestand openen",
      signed: "Ondertekend",
      your_signature: "Uw handtekening",
      signature: "Handtekening",
      tap_to_sign: "Tik om te tekenen",
      archive: "Archief",
      archive_description: "Werknemers hier nemen geen plekken in.",
      back_to_list: "Terug naar lijst",
      restore: "Herstellen",
      delete_permanently: "Definitief verwijderen",
      restore_confirm: "Weet u zeker dat u wilt herstellen:",
      delete_permanent_confirm: "WAARSCHUWING! Dit verwijdert de werknemer en historie definitief. Doorgaan?",
      restore_limit_error: "Kan niet herstellen! Planlimiet bereikt.",
      archive_empty: "Archief is leeg",
      archive_worker_confirm: "Werknemer archiveren?",
      archive_worker_desc: "Werknemer wordt gearchiveerd. Historie blijft behouden, plek in plan komt vrij.",
      photo_report_title: "FOTORAPPORTAGE",
      photo_num: "Foto",
      no_photos_yet: "Nog geen foto's",
      add_photo: "Foto toevoegen",
      general_comment_uppercase: "ALGEMENE OPMERKINGEN",
      general_comment: "Algemene opmerking",
      worker_signature: "Handtekening werknemer",
      client_signature: "Handtekening (Klant / Anders)",
      verified_by: "Geverifieerd door / Handtekening",
      save_offline_btn: "Opslaan (Offline)",
      send_btn: "Verzenden",
      sent_success: "Verzonden!",
      share: "Delen",
      empty_history: "Leeg",
      photo_comment_placeholder: "Opmerking...",
      reports_title: "Rapportages",
      no_photos_in_record: "Geen foto's in dit dossier.",
      generated_by_system: "Gegenereerd door BuildForce AL",
      no_comment: "Geen commentaar",
      status_viewed: "Bekeken",
      status_new: "Nieuw",
      status_completed: "Voltooid",
      view_all: "Bekijk alles",
      no_date: "Geen datum",
      generating: "Genereren...",
      download_pdf: "Download PDF",
      no_reports: "Geen rapporten gevonden.",
      unknown_worker: "Onbekend",
      unknown_project: "Onbekend",
      confirm_delete: "Weet u zeker dat u wilt verwijderen?",
      no_info: "Geen info",

      /* --- NAUJI (PROFILE & SHARE) --- */
      profile: "Profiel",
      personal_data: "Persoonlijke gegevens",
      data_managed_by_admin: "Gegevens worden beheerd door de beheerder.",
      shared_success: "Gedeeld",
      error_sending_failed: "Verzenden mislukt",
      share_error: "Delen mislukt"
    }
  }
};

const detectLanguage = () => {
  const saved = localStorage.getItem("language");
  if (saved) return saved;
  const browser = navigator.language.split("-")[0];
  if (resources[browser]) return browser;
  return "lt";
};

i18n.use(initReactI18next).init({
  resources,
  lng: detectLanguage(),
  fallbackLng: "lt",
  interpolation: { escapeValue: false }
});

i18n.on("languageChanged", (lng) => {
  localStorage.setItem("language", lng);
});

export default i18n;